import React from 'react'

const BaseGraphLine = ({ x1, y1, x2, y2, ...rest }) => <line x1={x1} x2={x2} y1={y1} y2={y2} {...rest} />

BaseGraphLine.displayName = 'BaseGraphLine'

export default BaseGraphLine
